import { render, staticRenderFns } from "./SearchFieldComponent.vue?vue&type=template&id=479b4462&"
import script from "./SearchFieldComponent.vue?vue&type=script&lang=js&"
export * from "./SearchFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports